export const headerTittles = {
    "Assinatura - Recarga Pontual": "Assinatura<br>Recarga Pontual",
    "Assinatura": "Assinatura",
    "Lista Online": "Lista Online",
    "Serasa Monitora": "Serasa Monitora",
    "Consulta e Cobrança de Dívidas": "Consulta de CPF/CNPJ e<br>Cobrança de Dívidas",
    "Saúde do seu Negócio": "Saúde do seu Negócio"
}